<template>
  <v-card class="main-content-card" flat>
    <v-toolbar flat>
      <v-toolbar-title>绩效计算批次管理</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-btn color="primary" class="ml-3" @click.native.stop="onNew">新建</v-btn>
      <v-spacer/>
      <v-text-field
        label="按名称检索…"
        v-model="searchName"
        v-on:keyup.enter="onSearchName"
        append-icon="search"
        :append-icon-cb="onSearchName"
      />
    </v-toolbar>
    <v-divider/>
    <v-data-table
      :headers="headers"
      :loading="loading"
      :total-items="total"
      :pagination.sync="pagination"
      item-key="dbid"
      :items="items"
      rows-per-page-text="每页记录数"
      no-data-text="没有数据。"
      no-results-text="没有符合条件的记录。"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1}}
        </td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.version.name }}</td>
        <td>{{ props.item.startdate }}</td>
        <td>{{ props.item.enddate }}</td>
        <td>{{ props.item.year }}</td>
        <td>{{ props.item.note }}</td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
          <v-btn icon class="mx-0"  slot="activator"  @click="onEdit(props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
            <span>编辑</span>
          </v-tooltip>
          <v-tooltip top>
          <v-btn icon class="mx-0"  slot="activator"  @click="onConfirmDel(props.item)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
            <span>删除</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0"
                   slot="activator" @click="onConfirmGenerate(props.item)">
              <v-icon color="teal">file_upload</v-icon>
            </v-btn>
            <span>绩效生成</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

    <v-dialog v-model="editDialog" max-width="700px" persistent>
      <v-card>
        <v-form v-model="editDialogValid" ref="editDialogRef" lazy-validation>
          <v-card-title>
            <span class="subheading">{{editFormTitle}}</span>
          </v-card-title>
          <v-progress-linear :indeterminate="true" height="2" v-if="editDialogLoading"/>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs5>
                  <v-text-field label="批次名称" required :rules="rules.name" v-model="editItem.name"/>
                </v-flex>
                <v-flex xs7>
                  <v-select
                    label="版本名称"
                    item-text="name"
                    item-value="dbid"
                    autocomplete
                    clearable
                    required
                    :rules="rules.versionId"
                    :loading="versionLoading"
                    :items="versionItems"
                    :search-input.sync="versionSearch"
                    v-model="editItem.versionId"
                    v-on:keyup.enter="onVersionSearch"
                    :append-icon-cb="onVersionSearch"
                    hint="输入关键词检索"
                    persistent-hint
                  />
                </v-flex>
                <v-flex xs4>
                  <v-menu
                    ref="startdateMenuRef"
                    lazy
                    :close-on-content-click="false"
                    v-model="startdateMenu"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    :return-value.sync="editItem.startdate"
                  >
                    <v-text-field
                      slot="activator"
                      label="开始日期"
                      required
                      :rules="rules.required"
                      v-model="editItem.startdate"
                      readonly
                    />
                    <v-date-picker
                      v-model="editItem.startdate"
                      locale="zh-cn"
                      type="date">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="startdateMenu=false">取消</v-btn>
                      <v-btn flat color="primary" @click="$refs.startdateMenuRef.save(editItem.startdate)">确认</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs4>
                  <v-menu
                    ref="enddateMenuRef"
                    lazy
                    :close-on-content-click="false"
                    v-model="enddateMenu"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    :return-value.sync="editItem.enddate"
                  >
                    <v-text-field
                      slot="activator"
                      label="结束日期"
                      required
                      :rules="rules.required"
                      v-model="editItem.enddate"
                      readonly
                    />
                    <v-date-picker
                      v-model="editItem.enddate"
                      locale="zh-cn"
                      type="date">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="enddateMenu=false">取消</v-btn>
                      <v-btn flat color="primary" @click="$refs.enddateMenuRef.save(editItem.enddate)">确认</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="时间段（年）" required :rules="rules.year" v-model="editItem.year"/>
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="备注" required :rules="rules.note" v-model="editItem.note"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="blue darken-1" flat @click.native="editDialog = false">取消</v-btn>
            <v-btn color="primary" @click.native="onSave">保存
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span>确定要删除该条目吗？</span>
        </v-card-title>
        <v-card-text class="headline">
          {{delMessage}}
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click.stop="delDialog=false">取消</v-btn>
          <v-btn color="primary" flat @click.stop="onDel">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="generateDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span>确定要提交生成本批次的绩效吗?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click.stop="generateDialog=false">取消</v-btn>
          <v-btn color="primary" flat @click.stop="onGenerate">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>
</template>
<script>
  export default {
    data() {
      return {
        baseURI: '/api/perf/batch/',
        searchName: '',
        loading: false,
        total: 0,
        items: [],

        // 检索条件
        filters: {
          name: '',
        },

        // 分页条件
        pagination: {
          page: 1,
          rowsPerPage: 25,
          sortBy: 'code.asc'
        },

        // 表头
        headers: [
          {text: '#', align: 'left', sortable: false, value: 'dbid', width: "2rem"},
          {text: '批次名称', align: 'left', sortable: true, value: 'name'},
          {text: '绩效版本', align: 'left', sortable: false, value: 'version'},
          {text: '开始时间', align: 'left', sortable: false, value: 'startdate'},
          {text: '结束时间', align: 'left', sortable: false, value: 'enddate'},
          {text: '时间段（年）', align: 'left', sortable: false, value: 'year'},
          {text: '备注', align: 'left', sortable: false, value: 'note'},
          {text: '操作', align: 'center', sortable: false, value: 'dbid'}
        ],
        startdateMenu:false,
        enddateMenu:false,
        // 新建/编辑对话框
        editDialog: false,
        editDialogValid: true,
        editDialogLoading: false,

        editIndex: -1,
        editDbid: null,
        editItem: null,
        defaultItem: null,
        freshItem: {
          "name": "",
          "versionId":"",
          "version":"",
          "startdate":"",
          "enddate":"",
          "year":"",
          "note":""
        },
        //版本号
        versionLoading: false,
        versionItems: [],
        versionSearch: "",
        /**
         * 验证规则
         */
        rules: {
          name: [
            v => !!v || '必填项。',
            v => (v && v.length <= 255) || '长度必须小于255个字符。'
          ]
        },

        // 删除对话框
        delDialog: false,
        delDialogLoading: false,

        delIndex: -1,
        delDbid: null,
        delMessage: '',

        // 绩效生成
        generateDialog: false,
        generateLoading: false,
        generateIndex: -1,
        generateDbid: null
      }
    },

    created() {
      // 组件创建完后获取数据，
      // 此时 data 已经被 observed 了

      // 复制默认的数据
      this.editItem = window.xutil.clone(this.freshItem)
    },

    watch: {
      // 如果路由有变化，则重新加载数据
      '$route': 'get',

      // 如果分页或排序有变化，则重新加载数据
      pagination: {handler: 'get', deep: true},
      // "pagination.page": 'get',
      // "pagination.rowsPerPage": 'get',
      // "pagination.sortBy": 'get',

      filters: {
        deep: true,
        handler: function () {
          if (this.pagination.page !== 0) {
            this.pagination.page = 0;
          } else {
            this.get();
          }
        }
      }
    },

    computed: {
      editFormTitle() {
        return this.editIndex === -1 ? '新建' : '编辑'
      }
    },

    methods: {
      remote(item, queryText, itemText) {
        // 用于远下拉框的过滤，所以所有选都是显示在下拉框中
        return true;
      },

      /**
       * **************************************************************
       * 事件响应函数
       */

      // 检索响应函数
      onSearchName() {
        this.filters.name = this.searchName
      },
      // 新建响应函数
      onNew() {
        this.$refs.editDialogRef.reset();
        this.editIndex = -1;
        this.editDbid = null;
        this.editItem = window.xutil.clone(this.freshItem);
        this.editDialog = true
      },

      // 编辑响应函数
      onEdit(item) {
        this.$refs.editDialogRef.reset();
        this.editIndex = this.items.indexOf(item);
        this.editDbid = item.dbid;
        this.editDialog = true;

        const vm = this;
        this.axios.get(this.baseURI + this.editDbid)
          .then(rsp => {
            const it = rsp.data;
            // 填充编辑对话框
            vm.editItem = it;
            vm.versionItems = item.version ? [item.version] : [];
            // 保存默认数据
            vm.defaultItem = window.xutil.clone(this.editItem);
          });
      },
      // 确认生成绩效响应函数
      onConfirmGenerate(item) {
        this.generateDbid = item.dbid;
        this.generateIndex = this.items.indexOf(item);
        this.generateDialog = true;
      },
      // 生成绩效响应函数
      onGenerate() {
        const vm = this;
        vm.generateLoading = true;
        this.axios.put('/api/perf/batch/generate/' + vm.generateDbid).then((rsp) => {
          vm.items[vm.generateIndex].state = rsp.data.state;
          vm.items[vm.generateIndex].dateModified = window.xutil.timestamp(rsp.data.dateModified);
          vm.generateIndex = -1;
          vm.generateLoading = false;
          vm.generateDialog = false;
        })
      },
      //检索版本
      onVersionSearch() {
        let params = {};
        if (this.versionSearch) {
          const val = this.versionSearch.trim();
          if (val.length > 0) {
            params["name"] = val;
          }
        }
        const vm = this;
        vm.versionLoading = true;
        this.axios.get('/api/perf/Version', {params: params}).then(
          rsp => {
            vm.versionLoading = false;
            vm.versionItems = rsp.data.items;
          })
      },
      // 保存响应函数
      onSave() {
        const vm = this;
        if (this.$refs.editDialogRef.validate()) {
          // 新建
          if (this.editIndex < 0) {
            // 以 POST 方式创建新记录
            this.axios.post(this.baseURI, this.editItem)
              .then(rsp => {
                vm.items.unshift(rsp.data);
                vm.total = vm.total + 1;
                vm.editDialog = false;
              })
          }
          //保存
          else {
            // 获取修改的字段
            const changes = window.xutil.changes(this.defaultItem, this.editItem);

            // 有修改的字段，以 PUT 方式保存修改
            if (Object.keys(changes).length > 0) {
              this.axios.put(this.baseURI + this.editDbid, changes)
                .then(rsp => {
                  vm.items[vm.editIndex] = rsp.data;
                  vm.editDialog = false;
                });
            }
            // 关闭对话框
            else {
              this.editDialog = false;
            }
          }
        }
      },

      // 确认删除响应函数
      onConfirmDel(item) {
        this.delMessage = item.name;
        this.delDbid = item.dbid;
        this.delIndex = this.items.indexOf(item);
        this.delDialog = true;
      },

      // 删除响应函数
      onDel() {
        const vm = this;
        vm.delDialogLoading = true;
        this.axios.delete(this.baseURI + vm.delDbid)
          .then(rsp => {
            vm.delDialogLoading = false;
            vm.items.splice(vm.delIndex, 1);
            vm.total = this.total - 1;
            vm.delIndex = -1;
            vm.delDialog = false;
          })
      },

      /**
       * **************************************************************
       * 异步请求
       */
      // 获取列表
      get() {
        window.console.log(JSON.stringify(this.query));
        const vm = this;
        const params = Object.assign(
          window.xutil.paramsPagination(vm.pagination),
          window.xutil.paramsFilters(vm.filters)
        );
        vm.loading = true;
        this.axios.get(vm.baseURI, {params: params})
          .then(rsp => {
            vm.loading = false;
            vm.items = rsp.data.items;
            vm.total = rsp.data.total;
          })
      }
    }
  }
</script>
